import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';
import { yupResolver } from '@hookform/resolvers/yup';
import { IonButton, IonCard, IonContent, IonHeader, IonItem, IonTitle, IonToolbar } from '@ionic/react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

import FormInput from '../../../components/form/formInput/FormInput';
import { pinInAsync, signOutAsync } from '../../../store/authSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { IonPageWrapper } from './PinInPage.styles';

interface IComponentProps { }

interface IFormInputs {
  pin: string;
}

const schema = yup.object().shape({
  pin: yup.string().required(''),
});

const PinInPage: React.FC<IComponentProps> = () => {
  const { isPinningIn } = useAppSelector(state => state.auth);

  const dispatch = useAppDispatch();

  const { control, handleSubmit, formState } = useForm<IFormInputs>({
    defaultValues: {
      pin: '',
    },
    mode: 'onChange',
    resolver: yupResolver(schema),
  });

  const onSubmit = handleSubmit((data) => {
    if (Capacitor.getPlatform() === 'ios' || Capacitor.getPlatform() === 'android') {
      Keyboard.hide();
    }
    dispatch(pinInAsync(data.pin));
  });

  const handleClickSignOut = () => {
    dispatch(signOutAsync());
  };

  return (
    <IonPageWrapper>
      <IonHeader color="lightest">
        <IonToolbar color="primary">
          <IonTitle>
            Technician PIN
          </IonTitle>
          <IonButton slot="end" size="small" onClick={() => handleClickSignOut()}>SIGN OUT</IonButton>
        </IonToolbar>
      </IonHeader>
      <IonContent color="lightest">
        <form id="techPinForm" noValidate onSubmit={onSubmit}>
          <IonCard>
            <IonItem lines="none">
              <FormInput control={control} type="password" placeholder="PIN" name="pin" hasLine={false} />
              <IonButton type="submit" slot="end" disabled={formState.errors.pin !== undefined || isPinningIn}>PIN IN</IonButton>
            </IonItem>
          </IonCard>
        </form>
      </IonContent>
    </IonPageWrapper>
  );
};

export default PinInPage;